import { Inject, Injectable } from '@angular/core';
import { API_URL } from '../../app-store-providers';
import { HttpClient } from '@angular/common/http';
import { EntityTypes } from '../../entity/entity-types';
import { DictionaryCarbonMaterial } from './models/carbon-material';
import { StoreBaseService } from '../../common/base.service';

@Injectable({
  providedIn: 'root'
})
export class DictionaryCarbonMaterialService
  extends StoreBaseService<DictionaryCarbonMaterial> {

  get entityType(): string {
    return EntityTypes.carbonMaterial;
  }

  get resourceName(): string {
    return 'carbon-material';
  }

  constructor(
    @Inject(API_URL) apiUrl: string,
    http: HttpClient
  ) {
    super(apiUrl, http);
  }
}
